export const DATE_DASH_FORMAT = 'yyyy-MM-dd';
export const TIME_FORMAT = 'HH:mm';
